// extracted by mini-css-extract-plugin
module.exports = {"likes":"Post_likes__2o7Hq"};